var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseSectionTitle',[_c('div',{staticClass:"text-body-1 pb-6"},[_vm._v(" Alles im Rudel. Ein Team. ")]),_vm._v(" Das sind wir. ")]),_c('BaseContainer',{staticClass:"my-14"},[_c('PlayerGallery',{attrs:{"entries":_vm.airsoftMembers}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }